import classnames from 'classnames';
import React, { DetailedHTMLProps, HTMLAttributes, useMemo } from 'react';

import { path } from 'common/tools/network/routing';
import trans from 'common/tools/translations/trans';

type RewindMenuProps = DetailedHTMLProps<
  HTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & { logged?: boolean };
const RewindMenu = ({ className, logged, ...props }: RewindMenuProps) => {
  const menuLabel = useMemo(() => trans('rewind.menu.button'), []);

  return (
    <a
      className={classnames(className, 'rewind-menu-link')}
      {...props}
      {...(logged
        ? { href: path('userspace_my_flashback') }
        : {
            href: `${path('signin')}?returnUrl=${path('userspace_my_flashback')}`
          })}
    >
      {menuLabel}
    </a>
  );
};

export default RewindMenu;
